module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<table>\n<tbody>\n<tr>\n<td>Ausgewählte Bilder:</td>\n<td><%= model.nrOfElements.nrOfSelectedElements || 0 %></td>\n<td><%= model.nrOfElements.formattedSizeOfSelectedElements || '' %></td>\n</tr>\n<tr>\n<td>Sichtbare Bilder:</td>\n<td><%= model.nrOfElements.nrOfShownElements || 0 %></td>\n<td><%= model.nrOfElements.formattedSizeOfShownElements || '' %></td>\n</tr>\n<tr>\n<td>Gefilterte Bilder:</td>\n<td><%= model.nrOfElements.nrOfMatchingElements || 0 %></td>\n<td><%= model.nrOfElements.formattedSizeOfMatchingElements || '' %></td>\n</tr>\n<tr>\n<td>Alle Bilder:</td>\n<td><%= model.nrOfElements.nrOfElements || 0 %></td>\n<td><%= model.nrOfElements.formattedSizeOfElements || '' %></td>\n</tr>\n</tbody>\n</table>\n</div>"
  , __filename = "components/templates/mediaManagement/image/nrOfElements.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<table>\n<tbody>\n<tr>\n<td>Ausgewählte Bilder:</td>\n<td>")
    ; __line = 6
    ; __append(escapeFn( model.nrOfElements.nrOfSelectedElements || 0 ))
    ; __append("</td>\n<td>")
    ; __line = 7
    ; __append(escapeFn( model.nrOfElements.formattedSizeOfSelectedElements || '' ))
    ; __append("</td>\n</tr>\n<tr>\n<td>Sichtbare Bilder:</td>\n<td>")
    ; __line = 11
    ; __append(escapeFn( model.nrOfElements.nrOfShownElements || 0 ))
    ; __append("</td>\n<td>")
    ; __line = 12
    ; __append(escapeFn( model.nrOfElements.formattedSizeOfShownElements || '' ))
    ; __append("</td>\n</tr>\n<tr>\n<td>Gefilterte Bilder:</td>\n<td>")
    ; __line = 16
    ; __append(escapeFn( model.nrOfElements.nrOfMatchingElements || 0 ))
    ; __append("</td>\n<td>")
    ; __line = 17
    ; __append(escapeFn( model.nrOfElements.formattedSizeOfMatchingElements || '' ))
    ; __append("</td>\n</tr>\n<tr>\n<td>Alle Bilder:</td>\n<td>")
    ; __line = 21
    ; __append(escapeFn( model.nrOfElements.nrOfElements || 0 ))
    ; __append("</td>\n<td>")
    ; __line = 22
    ; __append(escapeFn( model.nrOfElements.formattedSizeOfElements || '' ))
    ; __append("</td>\n</tr>\n</tbody>\n</table>\n</div>")
    ; __line = 26
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mediaManagement/image/nrOfElements.ejs

}